import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'
import VModal from 'vue-js-modal'
import Utils from '@/utils/Utils'
import ErrorUtils from '@/utils/ErrorUtils'
import Vuelidate from 'vuelidate'
import moment from 'vue-moment'
import redirectEnum from '@/constants/redirectEnum'

Vue.use(VueRouter)
Vue.use(VModal)
Vue.use(Vuelidate)
Vue.use(moment)

Vue.mixin(Utils)
Vue.mixin(ErrorUtils)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('@/views/Auth/Signup.vue'),
  },
  {
    path: '/signup/verify_email_send',
    name: 'VerifyEmailSend',
    component: () => import('@/views/Auth/VerifyEmailSend.vue'),
  },
  {
    path: '/signin',
    name: 'Signin',
    component: () => import('@/views/Auth/Signin.vue'),
    meta: { checkAuth: true }
  },
  {
    path: '/link/:redirectId',
    name: 'Link',
    component: () => import('@/views/Auth/Signin.vue'),
    meta: { checkAuth: true }
  },
  {
    path: '/password_reset_email_send',
    name: 'PasswordResetEmailSend',
    component: () => import('@/views/Auth/PasswordResetEmailSend.vue'),
  },
  {
    path: '/password_reset',
    name: 'PasswordReset',
    component: () => import('@/views/Auth/PasswordReset.vue'),
  },
  {
    path: '/withdraw/confirm',
    name: 'WithdrawConfirm',
    component: () => import('@/views/Auth/WithdrawConfirm.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/withdraw/completed',
    name: 'WithdrawCompleted',
    component: () => import('@/views/Auth/WithdrawCompleted.vue'),
  },
  {
    path: '/auth_action',
    name: 'AuthAction',
    component: () => import('@/views/Auth/AuthAction.vue'),
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('@/views/Account/Account.vue'),
    meta: { requiresAuth: true }
  },
  /* {
    path: '/account/profile/create',
    name: 'AccountProfileCreate',
    component: () => import('@/views/Account/AccountProfileCreate.vue'),
    meta: { requiresAuth: true }
  }, */
  {
    path: '/account/profile/create_completed',
    name: 'AccountProfileCreateCompleted',
    component: () => import('@/views/Account/AccountProfileCreateCompleted.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/profile/edit',
    name: 'AccountProfileEdit',
    component: () => import('@/views/Account/AccountProfileEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/photo',
    name: 'AccountPhoto',
    component: () => import('@/views/Account/AccountPhoto.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/email/edit',
    name: 'AccountEmailEdit',
    component: () => import('@/views/Account/AccountEmailEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/email/edit_completed',
    name: 'AccountEmailEditCompleted',
    component: () => import('@/views/Account/AccountEmailEditCompleted.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/email/recovery_completed',
    name: 'AccountEmailRecoveryCompleted',
    component: () => import('@/views/Account/AccountEmailRecoveryCompleted.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/password/edit',
    name: 'AccountPasswordEdit',
    component: () => import('@/views/Account/AccountPasswordEdit.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/password/edit_completed',
    name: 'AccountPasswordEditCompleted',
    component: () => import('@/views/Account/AccountPasswordEditCompleted.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/registerPhone',
    name: 'AccountRegisterPhone',
    component: () => import('@/views/Account/AccountRegisterPhone.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/editPhone',
    name: 'AccountEditPhone',
    component: () => import('@/views/Account/AccountEditPhone.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/phone/validate_completed',
    name: 'AccountValidatePhoneCompleted',
    component: () => import('@/views/Account/AccountValidatePhoneCompleted.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/account/validatePhone',
    name: 'AccountValidatePhoneCode',
    component: () => import('@/views/Account/AccountValidatePhoneCode.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/signin/validatePhone',
    name: 'SigninValidatePhoneCode',
    component: () => import('@/views/Auth/SigninValidatePhoneCode.vue'),
    props: true,
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import('@/views/Job/Jobs.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/jobs/:id',
    name: 'Job',
    component: () => import('@/views/Job/Job.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/rooms',
    name: 'Rooms',
    component: () => import('@/views/Community/Rooms.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/rooms/:id',
    name: 'Room',
    component: () => import('@/views/Community/Room.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('@/views/Terms.vue'),
  },
  {
    path: '/smiles',
    name: 'Smiles',
    component: () => import('@/views/Smile/Smile.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/insurance',
    name: 'Insurance',
    component: () => import('@/views/Insurance/Insurance.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/partner',
    name: 'Partner',
    component: () => import('@/views/Links/Partner.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/redirect',
    name: 'Redirect',
    component: () => import('@/views/Redirect.vue')
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/NotFound.vue'),
  },
  {
    path: '*',
    redirect: '404',
  },
]

var verifiedAccountProfile = false

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.checkAuth)) {
    /*  next()
     return  */
  }
  else if (!to.matched.some(record => record.meta.requiresAuth)) {
    next()
    return
  }
  var requiresAuthFunc = async function (user) {
    if (to.name == "AccountRegisterPhone" && user !== undefined && user !== null && user.phoneNumber !== null) {
      next({ name: 'Home' });
      return
    }
    if (to.name !== "AccountRegisterPhone" && to.name !== "AccountValidatePhoneCode" && to.name !== "AccountProfileCreateCompleted" && user !== null && user.phoneNumber == null) {// phone not registered redirect to phone register page
      next({ name: 'AccountRegisterPhone' });
    }
    if (to.name == "AccountValidatePhoneCode") {
      next();
    }
    if (to.name == "AccountProfileCreateCompleted") {
      next();
    }
    if (to.name == "AccountValidatePhoneCompleted") {
      next();
    }
    if (to.name == 'Signin' && from.name !== 'Account' && user) { // user already logged in
      const docRef = firebase.firestore().collection('usersLog').doc();
      await docRef.set({ uid: user.uid, type: "signin", source: window.location.href, created_at: firebase.firestore.FieldValue.serverTimestamp() });
      try { next({ name: 'Home' }) }
      catch (error) {
        //empty
      }
      return
    }
    if (to.name == 'Signin' && !user) { // user not logged in
      next()
      return
    }
    if (to.name == 'Link' && user) { // user logged in + redirect
      let redirectId = to.params.redirectId;
      let pid = to.query.pid;
      let source = window.location.href;
      if (pid == "0200001400" && redirectId == "job") {
        source = window.location.href.replace("job", "shopping");
        pid = "0600001400";
        redirectId = "shopping";
      }
      if (user && redirectId != undefined && redirectEnum.redirects[redirectId] !== undefined) { // Link redirect
        const docRef = firebase.firestore().collection('usersLog').doc();
        await docRef.set({ uid: user.uid, type: "signin", source: source, created_at: firebase.firestore.FieldValue.serverTimestamp(), redirectId: redirectId });
        if (pid !== undefined) {
          await docRef.set({ pid: pid }, { merge: true });
        }
        if (redirectEnum.redirects[redirectId].includes("http") && pid == undefined) {
          // http redirect
          next({ name: 'Redirect' });
          window.location.href = redirectEnum.redirects[redirectId];
        }
        else if (redirectEnum.redirects[redirectId].includes("http") && pid !== undefined) {
          next({ name: 'Home' });
        }
        else {
          next({ name: 'Partner', query: { target: redirectId, pid: pid } });
        }
      }
      else if (user && redirectEnum.redirects[redirectId] == undefined)
        next({ name: 'NotFound' });
      return
    }
    if (to.name == 'Link' && !user) { // user not logged in + redirect link
      next()
      return
    }
    if (to.name == 'JobPartner' && user) {
      firebase.firestore().collection('users').doc(user.uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const data = doc.data();
            if (data.pid == '0100000100') {
              next({ name: 'Home' })
            }
            else {
              next()
            }
          }
        });
    }
    if (router.currentRoute.name == "WithdrawCompleted") {
      // ここが退会完了画面ならリダイレクトなし
      return
    }
    if (!user) {
      next({ name: 'Signin', query: { redirect: to.fullPath } })
      verifiedAccountProfile = false
      return
    }
    if (to.name == 'VerifyEmailSend') {
      next()
      return
    }
    if (verifiedAccountProfile) {
      // User作成済みの確認が取れている場合はデータ量が無駄なので再確認しない
      next()
      return
    }
    firebase.firestore().collection('users').doc(user.uid).get().then((doc) => {
      if (doc.exists && user.phoneNumber !== '' && user.phoneNumber !== undefined) {
        verifiedAccountProfile = true
        next()
        return
      }
      // User未登録で、AccountRegisterPhone以外への遷移はAccountRegisterPhoneへ
      if (to.name == 'AccountRegisterPhone' || to.name == "AccountValidatePhoneCode") {
        next()
      } else {
        router.push({ name: 'AccountRegisterPhone' })
      }
    })
  }

  /*  const currentUser = firebase.auth().currentUser
   if (currentUser) {
     console.log("Current user exist")
     requiresAuthFunc(currentUser)
     return
   } */

  var authFlag = true;
  var unsub = firebase.auth().onAuthStateChanged(user => {
    if (authFlag) {
      authFlag = false;
      requiresAuthFunc(user)
      unsub();
    }
  })
  return
})

export default router
